<template>
    <div class="dialog-wrapper">
        <div class="dialog-box" :style="{ width: width }">

            <div class="dialog-title">{{title}}</div>

            <div class="dialog-body"><slot></slot></div>

            <div class="dialog-close" @click="$emit('close')">确定</div>

        </div>
    </div>
</template>

<script>
    export default {
        name: 'BaseDialog',
        props: {
            title: String,
            width: String,
        },
    };
</script>

<style scoped lang="scss">
    .dialog-wrapper {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        z-index: 100;

    }
    .dialog-box {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        background: #fff;
        z-index: 101;
        border-radius: 5px;

    }
    .dialog-close {
        bottom: 0px;
        color: #2d8cf0;
        font-size: 1rem;
        padding: 15px 10px;
    }
    .dialog-title {
        padding: 12px;
        color: #FFFFFF;
        font-size: 1rem;
        background: #2d8cf0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
    }
    .dialog-body {
        padding: 20px 25px 25px;
        text-align: left;
        font-size: 1rem;
        line-height: 1.5rem;
    }
</style>
